export const containerCardSkeleton = {
  display: 'flex',
  gap: '1rem',
};
